import type { TenantTypography } from '@/config/tenants/types'

export const WALMART_HEADING_SCALE: NonNullable<TenantTypography['scale']> = {
    h2: { fontSize: '24px', lineHeight: '32px' },
    h3: { fontSize: '24px', lineHeight: '32px' },
    h4: { fontSize: '20px', lineHeight: '28px' },
}
